// Stadium Trial — boss effect catalogue (content + data-driven effects).
//
// A boss encounter (pveTiers.ts) may reference effect ids via `effects: [...]`.
// The combat engine resolves them into modifiers applied to the boss's hits
// (see engine/pveEngine.ts → resolveBossModifiers). Effects REALLY change the
// simulation, and their name/description are surfaced at the Camp before the fight.

export type PveBossEffectId = "boss_berserker_scaling";

export interface PveBossEffectValues {
  damageGainPerMissingHpStep?: number; // + damage per step of missing HP
  missingHpStepPercent?: number;       // size of a step (% of max HP)
}

export interface PveBossEffectDef {
  id: PveBossEffectId;
  name: string;
  description: string;
  nameFr?: string;   // French (Stadium Trial i18n) — falls back to `name`
  descFr?: string;   // French — falls back to `description`
  nameKo?: string;   // Korean — falls back to `name`
  descKo?: string;   // Korean — falls back to `description`
  icon: string;
  effects: PveBossEffectValues;
}

export const PVE_BOSS_EFFECTS: Record<PveBossEffectId, PveBossEffectDef> = {
  boss_berserker_scaling: {
    id: "boss_berserker_scaling",
    name: "Berserker",
    description: "Gains +5% damage for every 10% max HP lost.",
    nameFr: "Berserker",
    descFr: "Gagne +5% de dégâts pour chaque tranche de 10% de PV max perdue.",
    nameKo: "버서커",
    descKo: "잃은 최대 체력 10%마다 +5% 데미지를 얻습니다.",
    icon: "😡",
    effects: { damageGainPerMissingHpStep: 0.05, missingHpStepPercent: 10 },
  },
};

export function getBossEffect(id: string): PveBossEffectDef | undefined {
  return (PVE_BOSS_EFFECTS as Record<string, PveBossEffectDef>)[id];
}
